import { useQuery } from "@tanstack/react-query";
import type { Models } from "@appwrite.io/console";
import { createConsoleClient } from "@/lib/appwrite-client";

export async function getUser(): Promise<Models.User | null> {
  try {
    const account = createConsoleClient().account;
    const currentUser = await account.get();
    return currentUser;
  } catch (error) {
    console.error("Error getting user", error);
    return null;
  }
}

export function useAuth(): {
  user: Models.User | null;
  isLoading: boolean;
} {
  const { data: user, isLoading } = useQuery({
    queryKey: ["auth", "user"],
    queryFn: getUser,
  });

  return {
    user: user as Models.User | null,
    isLoading: isLoading,
  };
}
